import {Mapper} from '@s-ui/domain'
import {slugify} from '@s-ui/js/lib/string'

export class FromSubscriptionModelsRawDataToSubscriptionModelsListValueObjectMapper extends Mapper {
  constructor({
    makeEntityFactory,
    modelEntityFactory,
    subscriptionModelValueObjectFactory,
    subscriptionModelsListValueObjectFactory
  }) {
    super()
    this._makeEntityFactory = makeEntityFactory
    this._modelEntityFactory = modelEntityFactory
    this._subscriptionModelValueObjectFactory = subscriptionModelValueObjectFactory
    this._subscriptionModelsListValueObjectFactory = subscriptionModelsListValueObjectFactory
  }

  map = subscriptionModelsRawData => {
    const {items = []} = subscriptionModelsRawData
    const subscriptionModelValueObjects = items
      .map(({makeId, modelId, name}) => {
        return modelId !== '0'
          ? this._subscriptionModelValueObjectFactory({
              make: this._makeEntityFactory({
                id: makeId
              }),
              model: this._modelEntityFactory({
                id: modelId,
                name,
                slug: slugify(name).replace(/-/g, '_')
              })
            })
          : false
      })
      .filter(Boolean)
    return this._subscriptionModelsListValueObjectFactory({
      items: subscriptionModelValueObjects
    })
  }
}
